import { ErrorType } from '../dictionaries/validationErrors'

/**
 * @typedef ErrorType
 */

/**
 * Get error description.
 * @param {ValidationError} error
 * @returns {string}
 */
export function getErrorDescription (error) {
  return error && error.description
}

/**
 * Get error type.
 * @param {ValidationError} error
 * @returns {ErrorType} type
 */
export function getErrorType (error) {
  return error && error.type
}

/**
 * Check if the error belongs to a email error.
 * @param {ValidationError} error
 * @returns {boolean}
 */
export function isEmailError (error) {
  return getErrorType(error) === ErrorType.Email
}

/**
 * Check if the error belongs to a username error.
 * @param {ValidationError} error
 * @returns {boolean}
 */
export function isUsernameError (error) {
  return getErrorType(error) === ErrorType.Username
}

/**
 * Check if the error belongs to a password error.
 * @param {ValidationError} error
 * @returns {boolean}
 */
export function isPasswordError (error) {
  return getErrorType(error) === ErrorType.Password
}

/**
 * Check if the error belongs to a sign in password error.
 * @param {ValidationError} error
 * @returns {boolean}
 */
export function isSignInPasswordError (error) {
  return getErrorType(error) === ErrorType.SignInPassword
}

/**
 * Check if the error belongs to a sign in username error.
 * @param {ValidationError} error
 * @returns {boolean}
 */
export function isSignInUsernameError (error) {
  return getErrorType(error) === ErrorType.SignInUsername
}

/**
 * Check if the error belongs to a comment error.
 * @param {ValidationError} error
 * @returns {boolean} isCommentError
 */
export function isCommentError (error) {
  return getErrorType(error) === ErrorType.Comment
}

/**
 * Check if the error belongs to a location zip code error.
 * @param {ValidationError} error
 * @readonly {boolean} isLocationZipCodeError
 */
export function isLocationZipCodeError (error) {
  return getErrorType(error) === ErrorType.LocationZipCode
}

export function isAfterAuctionError (error) {
  return getErrorType(error) === ErrorType.SoldAfterAuctionValue
}

/**
 * Check if the error belongs to a location zip code error.
 * @param {ValidationError} error
 * @readonly {boolean} isLocationZipCodeError
 */
export function isLocationCityError (error) {
  return getErrorType(error) === ErrorType.LocationCity
}

/**
 * Check if the error belongs to a access denied error.
 * @param {ValidationError} error
 * @readonly {boolean} isAccessDeniedError
 */
export function isAccessDeniedError (error) {
  return getErrorType(error) === ErrorType.LocationCity
}

/**
 * Check if the error belongs to a VIN error.
 * @param {ValidationError} error
 * @readonly {boolean} isVINError
 */
 export function isVINError(error) {
  return getErrorType(error) === ErrorType.VIN
}

export function hasError (error) {
  const types = Object.keys(ErrorType)
  return types.includes(getErrorType(error))
}
